import React, {useState, useEffect, useContext} from 'react'
import { db } from '../../Firebase/firebase'
import { Link } from 'react-router-dom'
import {ThemeContext} from '../../Context/ThemeContext/ThemeContext'
import {AuthContext} from '../../Context/AuthContext/AuthContext'

import firebase from 'firebase'

import './AsideNav.css'

const AsideNav = () => {
  const { isLight } = useContext(ThemeContext)
  const { currentUser } = useContext(AuthContext)
  const [platforms, setPlatform] = useState([])

  const createPlatform = () => {

    
    if(currentUser){
      const platformName = window.prompt("Name of the platform")

      if(platformName && platformName.length >= 3){
        db.collection('platform').where("platformName","==", platformName).get()
          .then(snapshot => {
            if(snapshot.docs.length === 0){
              db.collection('platform').add({
                platformName,
                createdAt: firebase.firestore.FieldValue.serverTimestamp()
              })
            } 
            else {
              alert(`TP/${platformName} already exists`)
            }
          })
      }
      else{
        alert("Atleast 3 characters")
      }
    }
    else {
      alert("You need to login to add platforms")
    }
  }

  useEffect(() => {
    db.collection('platform').orderBy("createdAt","asc").onSnapshot(snapshot => {
      setPlatform(snapshot.docs)
      // console.log(snapshot)
    })

  }, [])
  return (
    <aside className={`aside-nav ${isLight ? "" : "dark"}`}>
      <div className="aside-nav__container">
        <h1 className="aside-nav__header">
          Our Platforms
        </h1>
        {
          platforms.map(platform => {
            return(
              <div className="aside-nav__platform">
                <AsideNavPlatform platformName={platform.data().platformName}/>
              </div>
            )
          })
        }
        <button className="aside-nav__platform create" onClick={createPlatform}>
            <h2>
              Create
            </h2>
        </button>
      </div>
    </aside>
  )
}

const AsideNavPlatform = ({platformName}) => {
  
  return(


      <Link className="aside-nav-platform" to={`/platform/${platformName}`}>
        TP/{platformName}
      </Link>

    

  )
}

export default AsideNav